import React from 'react';
import { PRIVACY_POLICY, TERMS_OF_SERVICE } from '../lib/legalContent';

/**
 * LegalOverlay — a lightweight full-screen reader for the Privacy
 * Policy and Terms of Service. Reused from AuthScreen and Settings.
 * Zero design-language additions — inline styles only, matches the
 * calm editorial tone of the rest of the app.
 */
export default function LegalOverlay({ kind = 'terms', onClose }) {
  const doc = kind === 'privacy' ? PRIVACY_POLICY : TERMS_OF_SERVICE;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={doc.title}
      data-testid={`legal-overlay-${kind}`}
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(14,15,19,.45)',
        zIndex: 9999, display: 'flex', alignItems: 'stretch', justifyContent: 'center',
        padding: '32px 16px',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#FFFFFF', borderRadius: 20, maxWidth: 640, width: '100%',
          maxHeight: 'calc(100vh - 64px)', overflowY: 'auto',
          boxShadow: '0 30px 80px rgba(14,15,19,.28)',
          padding: '28px 24px 32px', color: '#232323',
          fontFamily: 'inherit',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
          <h2 style={{ margin: 0, fontFamily: 'Fraunces, serif', fontSize: 24, letterSpacing: -0.3 }}>
            {doc.title}
          </h2>
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            data-testid="legal-overlay-close"
            style={{ background: 'transparent', border: 'none', fontSize: 22, cursor: 'pointer', color: '#8A847C', padding: 4 }}
          >
            ×
          </button>
        </div>
        <p style={{ margin: '0 0 20px', fontSize: 12, color: '#8A847C' }}>
          Last updated · {doc.lastUpdated}
        </p>
        {doc.sections.map((s, i) => (
          <section key={i} style={{ marginBottom: 18 }}>
            <h3 style={{ margin: '0 0 6px', fontSize: 14, fontWeight: 600 }}>{s.h}</h3>
            {s.p && <p style={{ margin: '0 0 8px', fontSize: 13.5, lineHeight: 1.6, color: '#44454C' }}>{s.p}</p>}
            {s.list && (
              <ul style={{ margin: '0 0 8px 18px', padding: 0, fontSize: 13.5, lineHeight: 1.6, color: '#44454C' }}>
                {s.list.map((li, j) => <li key={j} style={{ marginBottom: 4 }}>{li}</li>)}
              </ul>
            )}
            {s.after && <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.6, color: '#44454C' }}>{s.after}</p>}
          </section>
        ))}
      </div>
    </div>
  );
}
